<div class="w-100">
    <color-chrome [color]="color" (onChangeComplete)="onChange($event)"></color-chrome>
</div>